import { useLocation, matchPath } from "react-router-dom";
import { Layout, Spin } from "antd";
import AppContainer from "./AppContainer";
import TopNavbar from "../../components/Header/TopNavbar";
import { useSelector } from "react-redux";

const AppLayout = ({ routers }) => {
  const location = useLocation();
  const { isRedirectingToPayment } = useSelector((state) => state.jobs);
  const currentRoute = routers.find((route) =>
    matchPath(route.path, location.pathname)
  );
  const showTopNav = currentRoute?.nav || false;

  return (
    <>
      <Layout style={{ minHeight: "100vh" }}>
        {isRedirectingToPayment && (
          <div className="payment-processing-overlay">
            <div className="processing-box glow-border">
              <Spin size="large" />
               <p style={{ marginTop: "1rem", color: "#fff", fontWeight: 500 }}>
                Redirecting to payment...
              </p>
              <p className="waiting-text">Please wait while we connect you to the payment gateway...</p>
            </div>
          </div>
        )}
        {window.location.pathname !== '/home' && showTopNav && <TopNavbar />}
        <Layout className="site-layout" >
          <AppContainer />
        </Layout>
      </Layout>
    </>
  );
};

export default AppLayout;
